<template>
    <div>
        <div class="container tw-text-center">
            <div class="cutout">
                <div
                    class="cutout__text text tw-font-bold tw-text-primary tw-underline tw-px-8 tw-cursor-pointer tw-transition-all tw-duration-300 tw-ease-in-out hover:tw-opacity-75"
                    @click="dialog = true"
                >
                    Masz kod zniżkowy?
                </div>
            </div>
        </div>
        <transition name="fade">
            <div
                v-if="dialog"
                class="tw-fixed tw-w-full tw-h-full tw-top-0 tw-right-0 tw-bg-primary/80 tw-z-50 tw-px-4"
                @click="handleDialogClick"
            >
                <transition name="moveup" appear>
                    <div
                        v-if="dialog"
                        class="tw-max-w-xl tw-bg-gray-50 tw-rounded-sm tw-shadow-lg tw-mt-24 tw-px-8 tw-py-12 tw-mx-auto tw-text-center tw-relative tw-overflow-hidden"
                        @click.stop
                    >
                        <div
                            v-if="isSaving"
                            class="tw-bg-white tw-opacity-50 tw-absolute tw-z-10 tw-w-full tw-h-full tw-top-0 tw-left-0 tw-transition-all tw-duration-300 tw-ease-in-out"
                        ></div>
                        <img class="tw-h-20 tw-mb-8" src="/gfx/register.svg" />
                        <div class="tw-text-4xl tw-font-bold mb-4">Aktywuj kod zniżkowy</div>
                        <div class="tw-pb-9 tw-relative">
                            <input
                                v-model="voucher"
                                type="text"
                                placeholder="Tu wpisz kod"
                                :disabled="isSaving"
                                required
                                class="tw-h-10 tw-px-4 tw-text-center tw-placeholder-gray-300 tw-bg-white tw-rounded-md tw-w-full tw-border tw-border-solid tw-border-gray-300 tw-outline-none tw-ring-0 focus:tw-ring-2 focus:tw-ring-primary/30 focus:tw-border-primary/70"
                            />
                            <div
                                v-if="error"
                                class="tw-text-center tw-text-sm tw-text-red-600 tw-absolute tw-bottom-2 tw-left-0 tw-w-full"
                            >
                                {{ error }}
                            </div>
                        </div>

                        <div class="tw-mb-8">
                            <button
                                :disabled="isSaving"
                                class="tw-w-32 tw-h-12 tw-inline-flex tw-items-center tw-justify-center tw-border-none tw-outline-none tw-bg-success tw-text-white tw-font-semibold tw-rounded-md focus:tw-outline-none focus:tw-ring focus:tw-ring-success focus:tw-ring-opacity-30 tw-transition-all tw-duration-500 tw-ease-in-out hover:tw-bg-opacity-75"
                                @click="save"
                            >
                                <template v-if="isSaving">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="tw-h-6 tw-w-6 tw-animate-spin"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                                        />
                                    </svg>
                                </template>
                                <template v-else>Aktywuj</template>
                            </button>
                        </div>
                        <div>
                            <div
                                class="tw-inline-block tw-font-bold tw-text-primary tw-cursor-pointer tw-underline tw-transition-all tw-duration-500 tw-ease-in-out hover:tw-opacity-75"
                                @click="dialog = false"
                            >
                                Nie mam kodu
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: 'Voucher',
        data() {
            return {
                dialog: false,
                voucher: '',
                error: '',
                isSaving: false,
                url: window.location.protocol + '//' + window.location.host,
            }
        },
        methods: {
            async save() {
                if (!this.isSaving && this.voucher) {
                    this.isSaving = true
                    const formData = new FormData()
                    formData.append('voucher', this.voucher)
                    const { data } = await this.$http.post(`${this.url}/send-voucher`, formData, {
                        'content-type': 'application/x-www-form-urlencoded',
                    })
                    if (!data.isError) {
                        this.error = ''
                        location.reload(true)
                    } else {
                        this.error = data.messages
                    }
                    this.isSaving = false
                }
            },
            handleDialogClick() {
                if (!this.isSaving) {
                    this.dialog = false
                }
            },
            handleEscPress(event) {
                if (event.key === 'Escape') {
                    if (!this.isSaving) {
                        this.dialog = false
                    }
                }
            },
        },
        created() {
            document.addEventListener('keyup', this.handleEscPress)
        },
        beforeDestroy() {
            document.removeEventListener('keyup')
        },
    }
</script>

<style>
    
</style>
